import './styles/index.scss'
import { debugText, isProd, isVendorXiBao, isWeixin } from './helpers'
import Vue from 'vue'
import router from './router'
import * as filters from './filters'
import { OneButton, OneIcon, OneToast } from './ui'
import App from './App.vue'
import * as services from './services'
import { createVendorUserToken, verifyUserToken } from '@/verification'
import Cookies from 'js-cookie'

// Plugins
Vue.use({
  install (Vue) {
    Vue.prototype.$t = (io) => io
  }
})

Vue.use(OneToast)
Vue.use(OneButton)
  .use(OneIcon)

Vue.config.productionTip = false
Vue.config.devtools = !isProd

// Install filters
Object.keys(filters)
  .forEach((key) => {
    Vue.filter(key, filters[key])
  })

function setupUI () {
  const app = new Vue({
    provide: {
      gState: services.state,
      gActions: services.actions
    },
    router,
    render: h => h(App)
  }).$mount('#app')

  try {
    if (Vue.config.devtools) {
      // noinspection JSUnresolvedVariable
      window.__VUE_DEVTOOLS_GLOBAL_HOOK__.Vue = app.constructor
    }
  } catch (e) { }
}

async function bootstrap () {
  const url = new URL(window.location.href)
  const needVerify = true

  let vendorPayload

  if (needVerify && (vendorPayload = isVendorXiBao())) {
    await createVendorUserToken(vendorPayload)
    return
  }
  if (needVerify && isWeixin() && !url.searchParams.has('__skip__verify__')) {
    // noinspection JSUnresolvedVariable
    await verifyUserToken(window.__oneAppConfig__)
  }
}

bootstrap()
  .then(setupUI)
  .catch(e => {
    console.error(e)

    if (!isProd) {
      debugText(e, '', true)
    }
  })